import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Button } from 'antd';
import { metersToKilometers } from 'shared/utils/calculate-distance/meters-to-kilometers';
import { formatDateTime } from 'shared/utils/time/format-date-time';
import { secondsToHours } from 'shared/utils/time/seconds-to-hours';
import styles from './trip-task-fleethand-info.module.scss';
import type { ITripTaskFleethandInfo } from './types';

export const TripTaskFleethandInfo = (props: ITripTaskFleethandInfo) => {
  const { tripTask } = props;
  const { t } = useTranslation('trip');
  const [isDetailsOpened, setIsDetailsOpened] = useState(false);

  if (!tripTask.fleethandId) {
    return null;
  }

  const handleOpenDetails = () => {
    setIsDetailsOpened((opened) => !opened);
  };

  return (
    <div className={styles.container}>
      <Flex justify='space-between' align='center' className={styles.contentWrapper}>
        {tripTask.fleethandEta && (
          <p className={styles.eta}>
            <strong>{t('fleethand_eta')}</strong>: {tripTask.fleethandEta}
          </p>
        )}

        <Button type='link' size='small' className={styles.button} onClick={handleOpenDetails}>
          {isDetailsOpened ? 'Show less' : 'Show more'}
        </Button>
      </Flex>

      {isDetailsOpened && (
        <>
          {tripTask.fleethandPlannedDistance && (
            <div>
              {t('fleethand_planned_distance')}: {metersToKilometers(tripTask.fleethandPlannedDistance)} km
            </div>
          )}
          {tripTask.fleethandPlannedDuration && (
            <div>
              {t('fleethand_planned_duration')}: {secondsToHours(tripTask.fleethandPlannedDuration)} h
            </div>
          )}
          {tripTask.fleethandActualDistance && (
            <div>
              {t('fleethand_actual_distance')}: {metersToKilometers(tripTask.fleethandActualDistance)} km
            </div>
          )}
          {tripTask.fleethandActualDuration && (
            <div>
              {t('fleethand_actual_duration')}: {secondsToHours(tripTask.fleethandActualDuration)} h
            </div>
          )}
          {tripTask.fleethandStartedAt && (
            <div>
              {t('fleethand_started')}: {formatDateTime(tripTask.fleethandStartedAt)}
            </div>
          )}
          {tripTask.fleethandDoneAt && (
            <div>
              {t('fleethand_done')}: {formatDateTime(tripTask.fleethandDoneAt)}
            </div>
          )}
          {tripTask.fleethandUpdateAt && (
            <div>
              {t('fleethand_updated_at')}: {formatDateTime(tripTask.fleethandUpdateAt)}
            </div>
          )}
          {tripTask.fleethandSyncAt && (
            <div>
              {t('fleethand_synced_at')}: {formatDateTime(tripTask.fleethandSyncAt)}
            </div>
          )}
        </>
      )}
    </div>
  );
};
